import React from "react";

import {landingPageStrings } from "constants/constantStrings";

import NoSystemAccessIcon from "assets/SvgIcon/NoSystemAccessIcon";

import "./index.scss";

const NoSystemAssignedScreen = () => (
  <div className="no-system-access">
    <div className="margin-auto text-center">
      <NoSystemAccessIcon />
      <div className="no-system-access--info">
        <label className="heading">{landingPageStrings.noSystemsAssigned}</label>
        <div className="message">
          {landingPageStrings.contactAdmin} <br />
          <label>{landingPageStrings.adminEmail}</label>
        </div>
      </div>
    </div>
  </div>
);

export default NoSystemAssignedScreen;
